export const readingConstants = {
	ReadingGetByFilterRequest : "READING_GETBYFILTER_STARTED",
	ReadingGetByFilterSuccess : "READING_GETBYFILTER_COMPLETED",
	ReadingGetByFilterFailure : "READING_GETBYFILTER_FAILED",

	ReadingGetDetailRequest : "READING_GETDETAIL_STARTED",
	ReadingGetDetailSuccess : "READING_GETDETAIL_COMPLETED",
	ReadingGetDetailFailure : "READING_GETDETAIL_FAILED",

	ReadingSaveRequest : "READING_SAVE_STARTED",
	ReadingSaveSuccess : "READING_SAVE_COMPLETED",
	ReadingSaveFailure : "READING_SAVE_FAILED",

	ReadingDeleteRequest : "READING_DELETE_STARTED",
	ReadingDeleteSuccess : "READING_DELETE_COMPLETED",
	ReadingDeleteFailure: "READING_DELETE_FAILED",

	ReadingTitleGetRequest: "READING_TITLE_GET_STARTED",
	ReadingTitleGetSuccess: "READING_TITLE_GET_COMPLETED",
	ReadingTitleGetFailure: "READING_TITLE_GET_FAILED",

	ReadingTextUpdateRequest: "READING_TEXT_UPDATE_STARTED",
	ReadingTextUpdateSuccess: "READING_TEXT_UPDATE_COMPLETED",
	ReadingTextUpdateFailure: "READING_TEXT_UPDATE_FAILED"
}